import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../types'
import { CmsConverterService, defaultFSCatalog } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColorContainerConverter extends CmsConverterService<ColorContainerData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      color: formData.st_container_color?.value?.identifier ?? '',
      fullWidth: formData.st_full_width?.value ?? false,
      elements: formData.st_content ?? defaultFSCatalog,
    }
  }
}

export const COLOR_CONTAINER_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ColorContainerData>>('ColorContainerConverter')

export interface ColorContainerData extends ConvertedComponentData {
  color: string;
  fullWidth: boolean;
  elements: FsCatalog;
}
